import { render, staticRenderFns } from "./LayoutContentTokens.vue?vue&type=template&id=1e40008c&scoped=true"
import script from "./LayoutContentTokens.vue?vue&type=script&lang=js"
export * from "./LayoutContentTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e40008c",
  null
  
)

export default component.exports